export default () => {
  const backArrowBtn = document.querySelector('.container-breadcrumb-bar .button-back');

  if (backArrowBtn) {
    backArrowBtn.addEventListener('click', function(e) {
      e.preventDefault();

      window.history.back();

    } ,false);
  }  

  const toggleBackBtn = (tgl) => {
    if (backArrowBtn) {
      if (tgl !== undefined) {
        backArrowBtn.style.display = tgl ? '' : 'none';
      }
      else {
        backArrowBtn.style.display = (backArrowBtn.style.display === 'none') ? '' : 'none';
      }
    }
  }

  window.eika = {
    ...window.eika,
    toggleBackBtn
  }

};
